export const mediaPc = () => {
  return `@media all and (min-width: 1201px)`
}
export const mediaTablet = () => {
  return `@media all and (max-width: 1200px)`
}
export const mediaMobile = () => {
  return `@media all and (max-width: 767px)`
}
